var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['qr-pop', { 'show-QrPop': _vm.isShowQrPop }]},[_c('div',{staticClass:"qr-bg-box"},[_c('div',{staticClass:"clqr-btn",on:{"click":_vm.clqrBtnClick}},[_c('img',{attrs:{"src":require("@/assets/clr_btn.png")}})]),_c('div',{staticClass:"qr-bg"}),_vm._m(0)])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"qr"},[_c('img',{attrs:{"src":require("@/assets/qr.png")}})])
}]

export { render, staticRenderFns }